export default __webpack_public_path__ + "static/media/fondo-mob.4b40c0b6.png";